const ledgerAccountCategoryIds = {
  ASSETS: '1',
  LIABILITIES: '3',
  EQUITY: '5',
  REVENUE: '6',
  COST_OF_SALES: '8',
  OPERATING_EXPENSES: '7',
};

export default ledgerAccountCategoryIds;
